'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Intl = require('../../utils/Intl');

var _Intl2 = _interopRequireDefault(_Intl);

var _CSSClassnames = require('../../utils/CSSClassnames');

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _Expand = require('../icons/base/Expand');

var _Expand2 = _interopRequireDefault(_Expand);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.VIDEO;
var BUTTON_CLASS = CLASS_ROOT + '__button';

var FullscreenButton = function (_Component) {
  _inherits(FullscreenButton, _Component);

  function FullscreenButton() {
    _classCallCheck(this, FullscreenButton);

    return _possibleConstructorReturn(this, (FullscreenButton.__proto__ || Object.getPrototypeOf(FullscreenButton)).apply(this, arguments));
  }

  _createClass(FullscreenButton, [{
    key: 'shouldComponentUpdate',


    // prevents unnecessarily updates/re-renders
    // only update component if the onClick prop changes
    value: function shouldComponentUpdate(nextProps) {
      return this.props.onClick !== nextProps.onClick;
    }
  }, {
    key: 'render',
    value: function render() {
      var a11yExpandButtonTitle = _Intl2.default.getMessage(this.context.intl, 'Toggle Fullscreen');

      return _react2.default.createElement(
        _Button2.default,
        { plain: true, className: BUTTON_CLASS, onClick: this.props.onClick,
          a11yTitle: a11yExpandButtonTitle },
        _react2.default.createElement(_Expand2.default, { className: BUTTON_CLASS + '__icon',
          colorIndex: 'brand' })
      );
    }
  }]);

  return FullscreenButton;
}(_react.Component);

FullscreenButton.displayName = 'FullscreenButton';
exports.default = FullscreenButton;


FullscreenButton.propTypes = {
  onClick: _propTypes2.default.func
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/grommet/components/video/FullscreenButton.js
// module id = 536
// module chunks = 0